import img1 from '../../Images/me.jpg';

export const homeObjOne = {
  id:'about',
  lightbg:false,
  lightText:false,
  lightTextdesc:true,
  topLine:'About Me',
  headline:'Who is Bilal?',
  description:"I am a Software Development Engineer, I graduated from York University and worked at Amazon from 2022-2023."+
  " I have always been fascinated by technology since I was a child and ever since I have "+
  "enjoyed learning as much about it as I could.",
  description2: "On a more personal note, in my free time I like driving and working on motorcycles(that's me on the right!) and cars,"+ 
    "reading (often fiction or philosophical books), playing video games(I'm a huge RPG fan),"+
    " or playing my guitar and piano. I also frequently exercise by going to the gym and occasionally biking.",
  imgStart:false,
  img:img1,
  alt:'img',
  dark:true,
  dark2:true,
  primary:1,
  darkText:true,
  pageVisible:true,
  size:true,
  disp:true

};
